 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		83: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"ibdPage","5":"legacyIbdPage","7":"ad-AdContainer","8":"components-analytics-analytics","9":"components-feature_feed-feature_feed","10":"TwitterIcon","11":"container","12":"fc_executive_board","13":"fc_link-fc_link","14":"post-content-body","15":"aboutUsWpPage","16":"author","17":"category_page","18":"components-not_found_component-not_found_component","19":"components-slug-slug","20":"customCollectionPage","21":"feed","22":"loginPage","23":"logoutPage","24":"magazineTagPage","25":"magazine_page","26":"myAccountPage","27":"newsletters_page_marketo","28":"notFoundPage","29":"offerPage","30":"playlistIndexPage","31":"playlistPage","32":"podcastPage","33":"post_page","34":"registerPage","35":"resetPasswordPage","36":"sitemapIndex","37":"sitemapPost","38":"stories","39":"subscribePage","40":"tagPage","41":"videoIndex","42":"videoPage","43":"views-containers-layouts-blank_layout-blank_layout","44":"views-containers-layouts-web_layout-web_layout","78":"MarketoNewsletterForm","79":"MicCarousel","80":"MicIcon","81":"MicMobileIconCarousel","82":"Success-SubmissionSuccess","84":"applications-most-innovative-companies","85":"brands_that_matter_2021","86":"brands_that_matter_page","87":"categoryLink","88":"components-BackgroundHighlight-BackgroundHighlight","89":"components-MultiTabList-MultiTabList","90":"components-QuickCarousel-QuickCarousel","91":"components-StickyBar-StickyBar","92":"components-all_feed-all_feed","93":"components-categories","94":"components-config-config","95":"components-editor_highlights-editor_highlights","96":"components-finite_scroll","97":"components-footer-footer","98":"components-franchise_intro-franchise_intro","99":"components-ibd_category-ibd_category","100":"components-image-image","101":"components-magazine_archive-magazine_archive","102":"components-masthead-masthead","103":"components-mcp_section-mcp_section","104":"components-mic_mobile_menu-mic_mobile_menu","105":"components-more-stories-component-more-stories-component","106":"components-newsletters-recaptcha","107":"components-notice","108":"components-piano-pianoBottomBanner","109":"components-podcast_tile-podcast_tile","110":"components-podcast_tile-podcast_tile_featured","111":"components-post-content-insert","112":"components-ranked","113":"components-recirc-recirc","114":"components-related_posts-related_posts","115":"components-related_slider-related_slider","116":"components-sectors_list-sectors_list","117":"components-social","118":"components-social-social","119":"components-top_50-top_50","120":"components-top_50_shuffle-top_50_shuffle","121":"components-video_megatron-video_megatron","122":"components-video_module-utils-video_module_ads","123":"components-video_module-video_module","124":"containers-pages-list_landers-bwi-2020","125":"containers-pages-list_landers-ibd-2020","126":"containers-pages-list_landers-mic-2021","127":"content-innovation_festival_banner","128":"content-sponsor_bar","129":"fc-components-main-components","130":"fc-components-main-components-StickyBar-StickyBar","131":"fc-components-main-containers","132":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","133":"fc-components-main-containers-IbdLayout-IbdLayout","134":"fc-components-main-containers-WciLayout-WciLayout","135":"fc-components-main-utils-ConditionalWrapper","136":"franchises-BtmApplyPage","137":"franchises-BwiApplyPage","138":"franchises-IbdApplyPage","139":"franchises-MicApplyPage","140":"franchises-NbttApplyPage","141":"franchises-WciApplyPage","142":"innovation_by_design_future_page","143":"innovation_by_design_page_franchise","144":"innovation_by_design_page_franchise_2023","145":"layouts","146":"layouts-mcp","147":"nav_main_menu-nav_main_menu","148":"package_article_list_entry","149":"packages-nav-package_sticky_nav","150":"post-content-sidebar"}[chunkId]||chunkId) + "." + {"1":"6ab95b420126b269360e","2":"9983f9380940c4be70ca","3":"7c5b1b281f92150b3441","4":"ec218045aa2d669049df","5":"d05878e1fc5d5fcc0f35","6":"e032d917b6f14287e715","7":"6f17fdc95a3d747564f8","8":"2079b66d4fb724a4dcfe","9":"fbc9e5078058e20042b9","10":"8f06e9d0f5ace133ab86","11":"2dd9c22be4ef71d2d4a0","12":"dce3ec00874c91fff235","13":"63132256f3c6273da6a9","14":"c96dde505debb86c0c11","15":"d00db9cc3a050b65e9ba","16":"9684f516301dbbb672d2","17":"e92c014d125da971319b","18":"8f3f750a70820925cfa8","19":"e5fec6db5d7761bcba5d","20":"655d81dbe89cdb73ca40","21":"0f94d83f8367484fea90","22":"5c511e47499d1ec17fe3","23":"14306b7b08f98ac4a8e0","24":"8cdb7a2b3ef4892bac4e","25":"3423939ea31cc28fcbce","26":"8d4a7fc56560c2ea5537","27":"6ce26aed7a492c72b164","28":"498701926661c939b065","29":"cbd9cd3799026b761a44","30":"701e4c277e170959b180","31":"9f34ca04ceb4fdac1e1a","32":"c0c30d7cdb85217704e1","33":"31ce2af425914fdee113","34":"d60476c9cfe69cc49961","35":"30a36d41d7651a130145","36":"b16ab880993f937cef05","37":"c165ac7ed8983862cc00","38":"2f26068fb0c16e4eb899","39":"0d8b232563adae2211e9","40":"3ae62a91ff2cd525d26e","41":"269ca29ee3567d681bc9","42":"af1d676f432190167c0b","43":"c24b472eff7d46e65c98","44":"e467172cc21bdc0b6696","45":"d57285e34fb9a0f6a26d","46":"02012a4a63c2c486f65d","47":"c2ca267aa12373e78269","48":"0aaf1ed9bd6b1ce80531","49":"a140ee331d5a7807a3da","50":"2dc6e82ded23e8ee9195","51":"90662be01dcc09dc6ea1","52":"5d8b9c8edc8ee3cd2e1d","53":"0e7f075f4d76b3901a41","54":"11d812b3d561b6c95a1b","55":"5d7018feb7efe68f5695","56":"806f1deee14e44149c51","57":"ac5acbbc8c0eae8336d1","58":"f4a0352817fb0361facb","59":"c895b75cc30344799fcd","60":"7412adeafce67df80b07","61":"42b03f26941f31c947c6","62":"0a51c64e06a86b202f39","63":"570fec0aae7eadec8894","64":"e0e3fd23bc67a2d929fd","65":"a6769a379b309cc3fff9","66":"2ec686a7f5f87a31fd29","67":"54352bb2d5c34696c021","68":"88dcf4ab85a17c0bdf4c","69":"cc47887f4bd228f16643","70":"f06af9c701eb9f7b77f9","71":"0e11cf07c3bf67efe25c","72":"a719709bef63882b8ad1","73":"094faf2394884cbe213f","74":"d05313197f251a1f240c","75":"c7c8eea67a343229bd1f","76":"fa7fde38d9f6e254992a","77":"26464062da29d8bddd0c","78":"a564fe2a1a15f34b9017","79":"ac6d8304a478288dda4c","80":"611024c93a2695a2fdd1","81":"c921d38117fe2fbf794e","82":"84306ce851d0442c4989","84":"622294a0869067d553a8","85":"ddcfa3bd93ff2fec0ad4","86":"d0c964ff6662ed39937f","87":"a8486a9f9d5248c7fddf","88":"4571650a6cac1b94805f","89":"938f068ef280edf0fcac","90":"824d91c447a8c5f569ab","91":"0f4a85eba2d88b26ef0d","92":"1722aa2b9089b5a054f6","93":"59b6b8aea60e15cf711e","94":"b5814df49886262046fa","95":"434d7effd354d63e27ac","96":"462fa34b44a75f5b7f3f","97":"a543efc1a5d671e44d28","98":"582330393832fe6817dc","99":"3bff9c335d4c5c27edad","100":"5adcef01bfe3f83b22ce","101":"7405731fb61eb40a337f","102":"5323b49ad3ec6b27a2bc","103":"9be6c285f3ec46b06047","104":"c16de33f19935ad7ee3c","105":"0bbe14979ee0237ae6d3","106":"3b4fb847b5f2fba092cd","107":"6dd8e615a158337ed9f1","108":"808e12d4ff36ebdc46d2","109":"20c3212a9857282295d8","110":"cca91d5586d0c90ad616","111":"8d244c7cc26ee1782819","112":"28850a82f97fcb941e4b","113":"6b4d6e03bb2f4e669e32","114":"ebdc1c4c00d03b003302","115":"4d96d13d719cad8bd8ad","116":"39ad229ca53616e9343f","117":"d094abaec56d1fae206c","118":"abf972010a39b833a921","119":"45769b151e85f390787b","120":"e5afd06d4d79c6fb6dc9","121":"bf8b34076e0698335af2","122":"8bbb2f18b28b26c1c11e","123":"ad7d69e69d1381d89e12","124":"4618d574cdd28204a26f","125":"1e9677b8ae67b90e2262","126":"23e5f16ec189f33ce09f","127":"375ffd0a4daa06ac6ee4","128":"6a0dca1fafec19545271","129":"630d4c3535d83559308d","130":"035a807e1f36771281db","131":"61ee6a972adcfc0fcb8a","132":"607fea33f59f9a9b6b57","133":"1ddfee6640454a3c6061","134":"6a5988c3451e34ccc7f7","135":"05c25622c275b38b305e","136":"d5d3cb472587a33901f3","137":"ca707da575918e1c907d","138":"850c44a3081bc4ae15ed","139":"f210e15b7ece1f25e361","140":"bcefbd8eea718f26b4ad","141":"889a79a7db7b85aae03e","142":"2f5d6671ffaa9bd6af52","143":"2d7ed038a052a96947a8","144":"947a01c6453c42444093","145":"b0be922667547bca6ad0","146":"02fc9fbb275a40e7c66f","147":"b55b97414d018b72bae1","148":"a9a080282d10d991eccc","149":"3ca400ead3fedc7ad243","150":"af32e452ace80a9193e1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([742,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
